import React from "react";

function PageTitle(props) {
    const { title, descriptionLines, titleStyle, titleTag } = props;
    return (
        <div className="title-card">
            <div className="title-wrap">
                <h2 style={titleStyle}>{title}</h2>
                <div className="title-tag-wrap">
                    {titleTag.map((data, index) => (
                        <div className={`title-tag title-tag-${index}`} key={index}>
                            {data}
                        </div>
                    ))}
                </div>
                {descriptionLines.map((line, index) => (
                    <p key={index}>{line}</p>
                ))}
            </div>
        </div>
    );
}

export default PageTitle;
